import React from "react";
import db from "../../../../constants/database";

const GoodToGreat = () => {
  return (
    <div className="font-abel bg-[#F1F3F7] py-10 md:py-20">
      <div className="max-w-[1300px] mx-auto px-3 w-full h-full">
        <div className="text-center max-w-[850px] mx-auto pb-10">
          <h2 className="text-[24px] md:text-[50px] leading-[109.9%] text-[#222222]">
            From Good Hire to Great Leader
          </h2>
          <p className="text-[16px] md:text-[20px] text-[#4E4E4E] pt-3">
            For a select group of our clients, we have extended our work beyond
            recruitment with Post-Placement Success Packages. These programs
            have already proven highly effective in helping executives settle in
            faster, deliver impact sooner, and stay engaged long-term.
          </p>
        </div>
        <div className="grid md:grid-cols-3 grid-cols-1 gap-3 w-full">
          {db?.cards?.map((item) => (
            <div key={item.id} className="col-span-1 bshadow py-3">
              <div className="max-w-[368px] mx-auto px-3">
                <h2 className="text-[17px] md:text-[18px] leading-[109.9%] text-[#222222] pt-3">
                  {item.text}
                </h2>
                <p className="text-[14px] md:text-[14.8px] text-[#4E4E4E] pt-3">
                  {item.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GoodToGreat;
